import React from 'react'

/**
 * Id del gradiente Rankmi IA referenciable desde CSS vía `fill: url(#rankmiAiGradient)`.
 * Permite teñir íconos SVG (FontAwesome) con el gradiente de marca.
 */
export const RANKMI_AI_GRADIENT_ID = 'rankmiAiGradient'

/** Gradiente sparkles del tag IA (Figma Tag IA: naranja → dorado) */
export const RANKMI_AI_TAG_SPARKLE_GRADIENT_ID = 'rankmiAiTagSparkleGradient'

/**
 * Define el gradiente SVG de marca Rankmi IA para reutilizar en íconos.
 * Equivale a: linear-gradient(90deg, #FF66A1 -18.3%, #FF5D2C 100%).
 * Es seguro renderizarlo varias veces: el navegador resuelve el id al primero presente.
 */
export const AiGradientDefs: React.FC = () => (
  <svg
    width="0"
    height="0"
    aria-hidden="true"
    focusable="false"
    style={{ position: 'absolute', width: 0, height: 0 }}
  >
    <defs>
      <linearGradient
        id={RANKMI_AI_GRADIENT_ID}
        x1="0%"
        y1="0%"
        x2="100%"
        y2="0%"
      >
        <stop offset="0%" stopColor="#FF66A1" />
        <stop offset="100%" stopColor="#FF5D2C" />
      </linearGradient>
      <linearGradient
        id={RANKMI_AI_TAG_SPARKLE_GRADIENT_ID}
        x1="0%"
        y1="0%"
        x2="100%"
        y2="0%"
      >
        <stop offset="12.5%" stopColor="#FF5D2C" />
        <stop offset="100%" stopColor="#FFC13F" />
      </linearGradient>
    </defs>
  </svg>
)

export default AiGradientDefs
